"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _xmlJs = _interopRequireDefault(require("xml-js"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function convertToCleanJson(data) {
  var json = _lodash.default.reduce(_lodash.default.keys(data), function (acc, key) {
    acc[key] = data[key].text;
    return acc;
  }, {});

  return json;
}

var S3PostUploader =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(S3PostUploader, _React$PureComponent);

  function S3PostUploader() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, S3PostUploader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(S3PostUploader)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "inputRef", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (e) {
      if (!(e.target instanceof window.HTMLInputElement)) {
        return;
      }

      var getCredentials = _this.props.getCredentials;
      getCredentials(e.target.files[0], _this.uploadToS3);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "assignRef", function (input) {
      var inputRef = _this.props.inputRef;
      _this.inputRef = input;
      if (inputRef && input) inputRef(input);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "uploadToS3", function (file, _ref) {
      var uploadUrl = _ref.uploadUrl,
          params = _ref.params;
      var formData = new FormData();
      var _this$props = _this.props,
          onStart = _this$props.onStart,
          onProgress = _this$props.onProgress,
          onFinish = _this$props.onFinish,
          onError = _this$props.onError;

      _lodash.default.keys(params).forEach(function (key) {
        return formData.append(key, params[key]);
      });

      if (onStart) onStart();
      formData.append('file', file);

      _this.clear();

      var config = onProgress ? {
        onUploadProgress: onProgress
      } : {};

      _axios.default.post(uploadUrl, formData, config).then(function (response) {
        return response.data;
      }).then(function (text) {
        var parsed = JSON.parse(_xmlJs.default.xml2json(text, {
          compact: true,
          elementNameFn: function elementNameFn(val) {
            return val.toLowerCase();
          },
          textKey: 'text'
        }));
        if (parsed.error) throw convertToCleanJson(parsed.error);
        return convertToCleanJson(parsed.postresponse);
      }).then(function (data) {
        return onFinish && onFinish(data, file);
      }).catch(function (error) {
        return onError && onError(error);
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "clear", function () {
      if (_this.inputRef) _this.inputRef.value = '';
    });

    return _this;
  }

  _createClass(S3PostUploader, [{
    key: "render",
    value: function render() {
      var accept = this.props.accept;
      return React.createElement("input", {
        type: "file",
        ref: this.assignRef,
        accept: accept,
        onChange: this.handleChange
      });
    }
  }]);

  return S3PostUploader;
}(React.PureComponent);

var _default = S3PostUploader;
exports.default = _default;